module.exports = __webpack_public_path__ + "static/devops-30c0a9990dbe2ad60b1a91b8528a10d3.svg";